import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
// import store from "./store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
	{
		path: "/",
		redirect: "/classified/initial",
		component: () => import("@/layouts/blank-layout/Blanklayout"),
		children: [
			{
				name: "classifiedInitial",
				path: "/classified/initial",
				component: () => import("@/views/classified/FormInitialPage"),
			},
			{
				name: "classifiedForm",
				path: "/classified/form",
				component: () => import("@/views/classified/FormPage"),
			},
		]
	}
  ],
});

import NProgress from "nprogress";
// import store from "./store/store";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
